export const notaSelecionadaProvider = Symbol("notaSelecionada");
export const comentarioProvider = Symbol("comentario");
export const campanhaInfoProvider = Symbol("campanhaInfo");
export const tipoDoProdutoInfoProvider = Symbol("tipoProdutoInfo");

export interface ICampanhaNPSParams {
  nomeCampanha: string;
  tipoCampanha: number;
  campanhaId: string;
  nomeDoGrupo: string | null;
}

export enum ETipoProduto {
  financas = 1,
  contabil = 2
}

export enum IStorageKeyStatus {
  visualizado = "Visualizado",
  respondido = "Respondido"
}

export enum EStepsPesquisa {
  escolherNota = 1,
  escreverComentario = 2,
  finalizar = 3
}

export interface ICampanhaProps {
  campanhaId: string;
  nomeDoGrupo: string;
  tipoCampanha: number;
  exibirCampanha: boolean;
}
